export const SECTION_GROUP_LABELS = {
  WS_PV_PLACEVALUE: "Place Value",
  WS_PV_ROUNDING: "Rounding",
  WS_FR_EQUIVALENT: "Equivalent Fractions",
  WS_FR_ADD_SUB: "Add & Subtract Fractions",
  WS_GE_ANGLES: "Angles",
  WS_WP_MULTISTEP: "Multi-step Problems",
  WS_BIDMAS: "BIDMAS",
  WS_PV_COMPARE_ORDER: "Compare and Order"

  // add gradually
};

export function getSectionGroupLabel(id) {
  return SECTION_GROUP_LABELS[id] || "Mixed Skills";
}
